import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './app/store';
import App from './app/App';
import AuthBootstrap from './features/auth/AuthBootstrap';
import { applyMode, getInitialMode } from './lib/theme';
import './styles/index.css';

applyMode(getInitialMode());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AuthBootstrap>
          <App />
        </AuthBootstrap>
      </BrowserRouter>
    </Provider>
  </StrictMode>,
);
